import { Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { ProjectDto } from "@/core/features/projects/project.dto";
import { WarehouseDto } from "@/core/features/warehouses/warehouse.dto";
import { OptionType } from "@/types/OptionType";

export class ProjectHasWarehouseDto extends BaseEntityDto {
  @Type(() => ProjectDto)
  project: ProjectDto;
  projectId: string;

  @Type(() => WarehouseDto)
  warehouse: WarehouseDto;
  warehouseId: string;

  mapEntityToOptionType(labels: string[]): OptionType {
    return {
      label: labels.join(" "),
      value: this.warehouseId,
    };
  }
}
